var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71953 1.16733C7.64691 1.52479 7.64691 1.8932 7.71953 2.25066H1.44216L5.53174 5.85924L8.26662 3.41091C8.49737 3.69637 8.78553 3.93416 9.11324 4.10695L5.5377 7.30874L1.16536 3.45099V9.83399H9.83203V4.36316C10.1895 4.43578 10.5579 4.43578 10.9154 4.36316L10.9154 10.3757C10.9154 10.6748 10.6729 10.9173 10.3737 10.9173H0.623698C0.324544 10.9173 0.0820312 10.6748 0.0820312 10.3757V1.70899C0.0820312 1.40984 0.324544 1.16733 0.623698 1.16733H7.71953ZM10.3737 3.33398C9.7931 3.33398 9.25664 3.02426 8.96637 2.52148C8.67609 2.01871 8.67609 1.39926 8.96637 0.896484C9.25664 0.393708 9.7931 0.0839844 10.3737 0.0839844C10.9542 0.0839844 11.4907 0.393708 11.7809 0.896484C12.0712 1.39926 12.0712 2.01871 11.7809 2.52148C11.4907 3.02426 10.9542 3.33398 10.3737 3.33398Z",
    fill: "#444F59",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.64b7c41f8b9e5822fa71a390304a4f8f.svg";
export { ForwardRef as ReactComponent };